<div [ngClass]="{ 'overview-container': tabs }" class="flex">
  @if (tabs) {
    <div class="tabs">
      @for (tab of tabs; track $index) {
        <button (click)="onTabChange($index)" [ngClass]="{ active: activeTabIndex === $index }">
          {{ tab.title | translate }}
        </button>
      }
    </div>
  }
  <div class="chart-wrapper">
    <div class="chart-loader-container">
      <!--      <monitor-ui-loader></monitor-ui-loader>-->
      <div [id]="chartId" data-automation="multi-stat-chart"></div>
    </div>
    @if (chart) {
      <div class="series-container">
        @for (serieName of seriesDistinct(); track $index) {
          <div
            (click)="toggleSerie(serieName)"
            class="flex items-center pointer"
            [ngClass]="{ hidden: hidden(serieName) }"
          >
            <div
              class="colored-square mr-3"
              [ngClass]="(hidden(serieName) ? 'border-color-' : 'background-color-') + ($index + 1)"
            ></div>
            {{ serieName }}
          </div>
        }
      </div>
    }
  </div>
</div>
